import { useDraggable } from '@dnd-kit/core';
import { Card, alpha } from '@mui/material';
import React, { CSSProperties, ReactNode } from 'react';

export interface DraggableClassroomStudentProps {
  children: ReactNode;
  id: string;
  isOver?: boolean;
  style?: CSSProperties;
}

const colorToGradient = (color: string) => `linear-gradient(to right, ${color}, ${color})`;

const DraggableClassroomStudent = ({ id, isOver, style = {}, ...props }: DraggableClassroomStudentProps) => {
  const { attributes, setNodeRef, listeners, transform } = useDraggable({ id });

  const transformStyle: CSSProperties = transform
    ? {
        position: 'relative', // We could make it absolute in the students list but there will be dragging artifacts
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: 'none',
        zIndex: 2,
        ...style,
      }
    : style;

  return (
    <Card
      ref={setNodeRef}
      sx={theme => ({
        cursor: 'grab',
        // We cannot set two background colors, so we need a background image using gradient
        backgroundImage: isOver
          ? `${colorToGradient(alpha(theme.palette.primary.main, 0.15))}, ${colorToGradient(
              theme.palette.background.paper,
            )}`
          : null,
        transition: '200ms ease-in transform',
      })}
      style={transformStyle}
      {...listeners}
      {...attributes}
      {...props}
    />
  );
};

export default DraggableClassroomStudent;
